module.exports = __webpack_public_path__ + "static/media/header-bg-4.6b8bd1dc.jpg";